import { CameraConfig, ModelBased, ModelBasedVisual } from "./ModelBasedVisual";

export interface DragonflyData extends ModelBased {

}

export class DragonflyVisual extends ModelBasedVisual implements DragonflyData {
  constructor() {
    super();
    this.renderOrder = 200;
  }
  
  public getType(): string {
    return 'DragonflyVisual';
  }

  _cameraConfigs: CameraConfig[] = [];
  public getCameras(): CameraConfig[] {
    return this._cameraConfigs;
  }
}